import { LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL } from "../../constants/logisticsCptSlabs";

export enum TextLabels {
  ORDERS = "Orders",
}

export const noImageFileURL =
  "https://garaaz-store.s3.ap-south-1.amazonaws.com/12f9acad4db84044a016377125fbd8c5.jpg";
export const fileDownloadImage =
  "https://garaaz-store.s3.amazonaws.com/088189fc8241416d8a9c79cee875d4e2.png";

export const epochPlatformEtaSeconds = -19800;

export enum OrderStatus {
  NEW = "NEW",
  CANCELLED = "CANCELLED",
  SUPPLIER_CANCELLED = "SUPPLIER_CANCELLED",
  ENQUIRY_CLOSED = "ENQUIRY_CLOSED",
  CANCEL = "CANCEL",
  DELETED = "DELETED",
  CBO = "CBO",
  ACK = "ACK",
  PICKED = "PICKED",
  READY = "READY",
  IN_REVIEW = "IN_REVIEW",
  COMPLETED = "COMPLETED",
  COMPLETE = "COMPLETE",
  ALLOCATE = "ALLOCATE",
  ALLOCATED = "ALLOCATED",
  REVOKED = "REVOKED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  READY_TO_DISPATCH = "READY_TO_DISPATCH",
  DISPATCHED = "DISPATCHED",
  SHIPPED = "SHIPPED",
  RETURN_REQUESTED = "RETURN_REQUESTED",
  CUSTOMER_RETURNED = "CUSTOMER_RETURNED",
  CUSTOMER_RETURN_REJECTED = "CUSTOMER_RETURN_REJECTED",
  SUPPLIER_RETURNED = "SUPPLIER_RETURNED",
  SUPPLIER_RETURN_REJECTED = "SUPPLIER_RETURN_REJECTED",
  DELIVERED = "DELIVERED",
  CUSTOMER_HOLD = "CUSTOMER_HOLD",
  BLOCKED = "BLOCKED",
  PART_CONVERSION_STARTED = "PART_CONVERSION_STARTED",
  PART_CONVERSION_COMPLETED = "PART_CONVERSION_COMPLETED",
  DRAFT_ESTIMATE_SHARED = "DRAFT_ESTIMATE_SHARED",
  DRAFT_ESTIMATE_RESPONDED = "DRAFT_ESTIMATE_RESPONDED",
}

export function getGaraazStateColor(stateName: OrderStatus) {
  switch (stateName) {
    case OrderStatus.NEW:
      return "#92E6A7";
    case OrderStatus.ACK:
      return "#FF8C00";
    case OrderStatus.PICKED:
      return "#2BA8DE";
    case OrderStatus.ENQUIRY_CLOSED:
      return "#1A7431";
    case OrderStatus.DELIVERED:
      return "#1A7431";
    case OrderStatus.ALLOCATED:
      return "#07BEB8";
    case OrderStatus.CBO:
      return "#936639";
    case OrderStatus.CANCELLED:
    case OrderStatus.SUPPLIER_CANCELLED:
      return "#85182A";
    case OrderStatus.READY_TO_DISPATCH:
      return "#BFAB25";
    case OrderStatus.IN_REVIEW:
      return "#6B46C1";
    case OrderStatus.DISPATCHED:
      return "#1A7431";
    case OrderStatus.SHIPPED:
      return "#2B6CB0";
    case OrderStatus.RETURN_REQUESTED:
      return "#92E6A7";
    case OrderStatus.CUSTOMER_RETURNED:
      return "#2DC653";
    case OrderStatus.CUSTOMER_RETURN_REJECTED:
      return "#E01E37";
    case OrderStatus.SUPPLIER_RETURNED:
      return "#1A7431";
    case OrderStatus.SUPPLIER_RETURN_REJECTED:
      return "#E01E37";
    case OrderStatus.ACCEPTED:
      return "#1A7431";
    case OrderStatus.REJECTED:
      return "#E01E37";
    case OrderStatus.CUSTOMER_HOLD:
      return "#e5383b";
    case OrderStatus.BLOCKED:
      return "#D00000";
    case OrderStatus.PART_CONVERSION_STARTED:
      return "#7B1FA2";
    case OrderStatus.PART_CONVERSION_COMPLETED:
      return "#3949AB";
    case OrderStatus.DRAFT_ESTIMATE_SHARED:
      return "#00897B";
    case OrderStatus.DRAFT_ESTIMATE_RESPONDED:
      return "#0277BD";
  }
}

export function getSupplierStateColor(stateName: OrderStatus) {
  switch (stateName) {
    case OrderStatus.NEW:
      return { color: "#92E6A7", textColor: "black" };
    case OrderStatus.ACK:
      return { color: "#FF8C00", textColor: "black" };
    case OrderStatus.PICKED:
      return { color: "#2BA8DE", textColor: "white" };
    case OrderStatus.CBO:
      return { color: "#936639", textColor: "white" };
    case OrderStatus.REVOKED:
      return { color: "#9932CC", textColor: "white" };
    case OrderStatus.READY:
      return { color: "#1A7431", textColor: "white" };
    case OrderStatus.IN_REVIEW:
      return { color: "#6B46C1", textColor: "white" };
    case OrderStatus.CANCELLED:
      return { color: "#85182A", textColor: "white" };
    case OrderStatus.RETURN_REQUESTED:
      return { color: "#92E6A7", textColor: "black" };
    case OrderStatus.ACCEPTED:
      return { color: "#1A7431", textColor: "white" };
    case OrderStatus.REJECTED:
      return { color: "#E01E37", textColor: "white" };
  }
}

export enum OrderActions {
  CUSTOMER_RETURNED = "CUSTOMER_RETURN_ACCEPT",
  CUSTOMER_RETURN_REJECTED = "CUSTOMER_RETURN_REJECT",
  SUPPLIER_RETURNED = "SUPPLIER_RETURN_ACCEPT",
  SUPPLIER_RETURN_REJECTED = "SUPPLIER_RETURN_REJECT",
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
  CUSTOMER_UNHOLD = "CUSTOMER_UNHOLD",
  UNBLOCK = "UNBLOCK",
  START_PART_CONVERSION = "START_PART_CONVERSION",
  COMPLETE_PART_CONVERSION = "COMPLETE_PART_CONVERSION",
}

export enum ORDER {
  ALLGARAAZORDERS = "ALLGARAAZORDERS",
  ORDERHANDLER = "ORDERHANDLER",
  GET_ALL_SUPPLIERS = "GET_ALL_SUPPLIERS",
  BRANDS_INFO = "BRANDS_INFO",
  ACTIVE_SUBSCRIPTION_CUSTOMERS = "ACTIVE_SUBSCRIPTION_CUSTOMERS",
  SINGLEGARAAZORDER = "SINGLEGARAAZORDER",
  ORDERSTATSBYORDERHANDLER = "ORDERSTATSBYORDERHANDLER",
  ALLORDERHANDLERS = "ALLORDERHANDLERS",
  INSURANCE_USERS = "INSURANCE_USERS",
  SAMEPARTORDERS = "SAMEPARTORDERS",
  CARMAKERS = "CARMAKERS",
  SUPPLIER_PART_AVAILABILITY = "SUPPLIER_PART_AVAILABILITY",
  PART_CONFIRMATION_RESPONSES = "PART_CONFIRMATION_RESPONSES",
  PART_CONFIRMATIONS_FOR_ORDER = "PART_CONFIRMATIONS_FOR_ORDER",
  SUPPLIER_INVENTORY_DELTAS = "SUPPLIER_INVENTORY_DELTAS",
}

export enum CUSTOMERS {
  UNIQUECUSTOMERSTODAY = "UNIQUECUSTOMERSTODAY",
  DISTINCT_CUSTOMER_STATES = "DISTINCT_CUSTOMER_STATES",
  UNIQUECUSTOMERYESTERDAYANDTHISMONTH = "UNIQUECUSTOMERYESTERDAYANDTHISMONTH",
}

export enum OrdersTextLabels {
  ORDER_DELETED = "Order deleted successfully!",
  SOMETHING_WENT_WRONG = "Something went wrong",
  ERROR_ON_FILE_LOAD = "Error occurred while extracting file contents",
  INVOICE_UPLOADED_SUCCESSFULLY = "Invoice uploaded successfully!",
  CHALLAN_UPLOADED_SUCCESSFULLY = "Challan uploaded successfully",
  INVALID_PDF_CONTENT = "Please ensure that the Invoice number does not exceed 16 characters. It can contain alphabets, numerals, hyphens(-), and/or slash(/).",
  ACCESS_DENIED_ORDER_STATUS_INVALID = "Action Denied : Order State Invalid!",
  CBO_STATE_INVALID = "Action Denied : Order State Invalid or Requested Supplier State Invalid",
}

export enum CustomerType {
  PLATFORM = "PLATFORM",
  SUBSCRIBED = "Subscribed",
  PPD = "PPD",
  XPRESS = "Xpress",
}

export enum Roles {
  OPERATIONS_LEAD = "OPERATIONS_LEAD",
  EXECUTIVE = "EXECUTIVE",
  HEAD_OF_OPERATIONS = "HEAD_OF_OPERATIONS",
  ORDER_HANDLER = "ORDER_HANDLER",
  CODE_ALCHEMISTS = "CODE_ALCHEMISTS",
}

export enum EngagementMode {
  PLATFORM = "PLATFORM",
  SUBSCRIBED = "SUBSCRIBED",
  EXPIRED = "EXPIRED",
}

export enum PaymentType {
  PREPAID = "PREPAID",
  POSTPAID = "POSTPAID",
}

export enum DeliveryModes {
  DOOR_DELIVERY = "DOOR_DELIVERY",
  SELF_PICKUP = "SELF_PICKUP",
}

export enum DispatchMode {
  SELF_DISPATCH = "SELF_DISPATCH",
  SELF_PICKUP = "SELF_PICKUP",
  SYSTEM_PORTER = "SYSTEM_PORTER",
}

export enum OrderPayableBy {
  CUSTOMER = "CUSTOMER",
  INSURANCE = "INSURANCE",
  NBFC = "NBFC",
}

export enum OrderPayableTo {
  GARAAZ = "GARAAZ",
  SUPPLIER = "SUPPLIER",
}

export enum CPTSlabForManualOption {
  INSTANT_DELIVERY = 1,
  STANDARD_DELIVERY = 2,
  SELF_PICKUP = -2,
}

export const CPTSlabManualDisplay: Record<CPTSlabForManualOption, string> = {
  [CPTSlabForManualOption.INSTANT_DELIVERY]:
    LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL["1"],
  [CPTSlabForManualOption.STANDARD_DELIVERY]:
    LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL["2"],
  [CPTSlabForManualOption.SELF_PICKUP]:
    LOGISTICS_CPT_SLAB_LABELS_BY_LEVEL["-2"],
};

export enum TransactionType {
  FACILITATION = "Facilitation",
  TRADING = "Trading",
}

/**
 * Parts fulfillment signal on an estimate split (ops configuration).
 * Distinct from split lifecycle status (ACTIVE / HOLD / …).
 */
export enum EstimateSplitFulfillmentStatus {
  FULFILLED = "FULFILLED",
  CONFIRMATION_NEEDED = "CONFIRMATION_NEEDED",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export const ESTIMATE_SPLIT_FULFILLMENT_STATUS_LABELS: Record<
  EstimateSplitFulfillmentStatus,
  string
> = {
  [EstimateSplitFulfillmentStatus.FULFILLED]: "Full Fulfillment",
  [EstimateSplitFulfillmentStatus.CONFIRMATION_NEEDED]: "Confirmation Needed",
  [EstimateSplitFulfillmentStatus.NOT_AVAILABLE]: "Not Found",
};

export enum OrderTypes {
  REGULAR = "REGULAR",
  VIRTUAL = "VIRTUAL",
  RETURN = "RETURN",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export enum OrderHandlerAllocationType {
  PARENT = "Parent",
  RANDOM = "Random",
}

export enum InvoiceStatus {
  PAID = "PAID",
  UNPAID = "UNPAID",
  RECEIVED = "RECEIVED",
}

export enum VehicleType {
  TWO_WHEELER = "TWO_WHEELER",
  THREE_WHEELER = "THREE_WHEELER",
  OTHER = "OTHER",
}

export enum BillingEntity {
  INSURANCE_COMPANY = "INSURANCE_COMPANY",
  CUSTOMER = "CUSTOMER",
  END_CUSTOMER = "END_CUSTOMER",
}

export enum OrderPopoverLabels {
  PARENT = "PARENT",
  ENQUIRY = "ENQUIRY",
  PARENT_ORDER_NO = "Parent Order No.",
  ENQUIRY_NO = "Enquiry No.",
}

export enum EventBusTypes {
  ORCA_ORDER_ACTION_EVENT = "ORCA_ORDER_ACTION_EVENT",
}

export enum EventBusEventNames {
  REGENERATE_ORDER_INVOICE = "REGENERATE_ORDER_INVOICE",
  REGENERATE_DELIVERY_INVOICE = "REGENERATE_DELIVERY_INVOICE",
  REGENERATE_CONSOLIDATED_ORDER_INVOICE = "REGENERATE_CONSOLIDATED_ORDER_INVOICE",
}
